import React from 'react';
import MindMap from './variants/MindMap';
import './WorkflowUseCases.css';

const WorkflowUseCases = () => {
  return (
    <section className="wuc-section">
      <div className="wuc-grid">
        {/* Left: mind-map visual */}
        <div className="wuc-right">
          <MindMap />
        </div>

        {/* Right: title + cards */}
        <div className="wuc-left">
          <div className="wuc-eyebrow">One platform. Endless agents.</div>
          <h2 className="wuc-title">Stop prompting your agents. Engineer them.</h2>

          <div className="wuc-cards">
            <div className="wuc-card">
              <h3>Agents that prompt themselves</h3>
              <p>
                They find the work, do it, prove it's done, and ship it on their own cadence.
                You build the thing that builds the thing.
              </p>
            </div>

            <div className="wuc-card">
              <h3>The entire harness, one cloud</h3>
              <p>
                Scheduling, isolated worktrees, durable skills, real tools, and a verifier that
                holds the bar — develop locally, deploy as bundles, trigger from anywhere.
              </p>
            </div>

            <div className="wuc-card">
              <h3>You stay the engineer</h3>
              <p>
                Not the person who presses go. Compose each step, pick the agent per node —
                Claude, Codex, or Gemini — and keep judgment where it belongs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkflowUseCases;
